import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b61b4ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "single-line-icon"
}
const _hoisted_2 = ["placeholder", "value", "disabled", "type", "id"]

import { computed, ref } from 'vue';
import Mark from '@ui-kit/mark/Mark.vue';
import { vMaska as vMask, MaskOptions } from 'maska';

interface Props {
  modelValue?: string|number,
  disabled?: boolean,
  placeholder?: string,
  errors?: string|string[],
  type?: string,
  id?: string,
  icon?: string,
  flat?: boolean,
  mask?: string|string[];
  small?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SingleLine',
  props: {
    modelValue: null,
    disabled: { type: Boolean },
    placeholder: null,
    errors: null,
    type: null,
    id: null,
    icon: null,
    flat: { type: Boolean },
    mask: null,
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  modelValue?: string|number,
  disabled?: boolean,
  placeholder?: string,
  errors?: string|string[],
  type?: string,
  id?: string,
  icon?: string,
  flat?: boolean,
  mask?: string|string[];
  small?: boolean;
}



const hasErrors = computed(() => {
  const { errors } = props;
  if (errors){
    return Array.isArray(errors) ? errors.length > 0 : true;
  }
  return false;
});
const isPassword = computed(() => props.type === 'password');
const passwordShow = ref<boolean>(false);
const computedType = computed(() => {
  if (props.type === 'password') {
    const passwordType = passwordShow.value ? 'text' : 'password';
    return isPassword.value ? passwordType : props.type;
  } else if (props.type === 'number') {
    return 'tel';
  }
  return props.type;
});

const maskOpts = computed<MaskOptions>(() => {
  if (props.type === 'number') {
    return {
      mask: 'a.xx',
      tokens: {
        a: {
          multiple: true,
          pattern: /[0-9]/,
        },
        x: {
          optional: true,
          pattern: /[0-9]/,
        },
      }
    }
  }
  return {
    mask: props.mask,
  }
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["single-line-wrapper", {
      'small': __props.small,
      'has-icon': !!__props.icon,
      'password-type': _unref(isPassword),
      'has-errors': _unref(hasErrors),
      'flat': __props.flat,
    }])
  }, [
    (__props.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_FontAwesomeIcon, { icon: __props.icon }, null, 8, ["icon"])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      class: _normalizeClass(["single-line", { error: _unref(hasErrors) }]),
      placeholder: __props.placeholder,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('enter', $event)), ["enter"])),
      value: __props.modelValue,
      disabled: __props.disabled,
      type: _unref(computedType),
      id: __props.id
    }, null, 42, _hoisted_2), [
      [_unref(vMask), void 0, _unref(maskOpts)]
    ]),
    (_unref(isPassword))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["password-eye", {'password-show': passwordShow.value}]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (passwordShow.value = !passwordShow.value))
        }, [
          _createVNode(_component_FontAwesomeIcon, { icon: "eye" })
        ], 2))
      : _createCommentVNode("", true),
    (_unref(hasErrors))
      ? (_openBlock(), _createBlock(Mark, {
          key: 2,
          class: "mark",
          "tooltip-message": __props.errors
        }, null, 8, ["tooltip-message"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})